import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import SegmentListRequest from "../request/SegmentListRequest";
import { SegmentListApiResponse } from "../model/Segment";

export const SegmentListApiService = async (
  request: SegmentListRequest
): Promise<SegmentListApiResponse> => {
  const url = "/segments/";
  const { data } = await axios.get(url, {
    params: request,
  });
  if (data?.results) {
    return data;
  }
  const results = Array.isArray(data) ? data : [];
  return { results, count: results.length, pages: results.length > 0 ? 1 : 0 };
};

const useSegmentListApiService = (
  request: SegmentListRequest,
  enabled = true
): UseQueryResult<SegmentListApiResponse, AxiosError> =>
  useQuery<SegmentListApiResponse, AxiosError>(
    ["SegmentListApiService", ...Object.values(request)],
    () => SegmentListApiService(request),
    { keepPreviousData: true, enabled }
  );

export default useSegmentListApiService;
